
import { useEffect } from 'react';
import { getLoginRedirectURL } from 'src/utilities/checkCookie';
import { Loader } from 'src/components/FullScreenLoader/Loader';

export function RedirectToLogin () {
  useEffect(() => {
    (async function () {
      window.location = await getLoginRedirectURL();
    })();
  }, []);

  return <Loader type='fullScreen'/>;
}
